export default __webpack_public_path__ + "static/media/loginOut.515558c2.svg";